import { v4 as uuid } from 'uuid';
import { env } from '@/core/config/env';
import { encolar, drenar } from './offlineQueue';
import { enviarLog } from './logBackend';
const NIVELES_REMOTOS = ['WARNING', 'ERROR', 'CRITICAL'];
function inferirClaseFuncion() {
    try {
        const stack = new Error().stack ?? '';
        const lineas = stack.split('\n');
        const linea = lineas[3];
        if (!linea)
            return {};
        const m = linea.match(/at\s+(?:(.+?)\.)?(.+?)\s/);
        if (m)
            return { clase: m[1], funcion: m[2] };
        return {};
    }
    catch {
        return {};
    }
}
async function publicar(entry) {
    try {
        await enviarLog(entry);
    }
    catch {
        encolar(entry);
    }
}
function log(nivel, mensaje, contexto) {
    if (env.isDev) {
        const fn = nivel === 'ERROR' || nivel === 'CRITICAL' ? console.error : console.warn;
        fn(`[${nivel}] ${mensaje}`, contexto ?? '');
    }
    if (!NIVELES_REMOTOS.includes(nivel))
        return;
    const { clase, funcion } = inferirClaseFuncion();
    const entry = {
        id: uuid(),
        nivel: nivel,
        mensaje,
        clase,
        funcion,
        contexto,
        timestamp: new Date().toISOString(),
    };
    void publicar(entry);
}
export const logger = {
    debug: (msg, ctx) => log('DEBUG', msg, ctx),
    info: (msg, ctx) => log('INFO', msg, ctx),
    warning: (msg, ctx) => log('WARNING', msg, ctx),
    error: (msg, ctx) => log('ERROR', msg, ctx),
    critical: (msg, ctx) => log('CRITICAL', msg, ctx),
};
export function instalarHandlersGlobales() {
    window.addEventListener('error', (e) => {
        logger.critical('window.error', { mensaje: e.message, archivo: e.filename, linea: e.lineno });
    });
    window.addEventListener('unhandledrejection', (e) => {
        const mensaje = e.reason instanceof Error ? e.reason.message : String(e.reason);
        logger.critical('unhandledrejection', { mensaje });
    });
}
export async function drenarColaSiAplica() {
    const pendientes = drenar();
    for (const entry of pendientes) {
        void publicar(entry);
    }
}
